(() => {
  const initToiletpaperFlower = (section) => {
    if (!section || section.dataset.toiletpaperFlowerInitialized === 'true') return;

    const trigger = section.querySelector('[data-toiletpaper-flower-trigger]');

    if (!trigger) return;

    section.dataset.toiletpaperFlowerInitialized = 'true';

    trigger.addEventListener('click', () => {
      section.classList.toggle('is-active');
    });
  };

  const initAllToiletpaperFlowers = () => {
    document
      .querySelectorAll('[data-toiletpaper-flower]')
      .forEach(initToiletpaperFlower);
  };

  document.addEventListener('DOMContentLoaded', initAllToiletpaperFlowers);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-toiletpaper-flower]');

    if (section) {
      initToiletpaperFlower(section);
    }
  });
})();